import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Employees } from 'src/app/components/off-roll-leave-lop-management/off-roll-leave-lop-management.component';
import { environment } from 'src/environments/environment';

export interface EmployeeResponse {
  success: boolean;
  message: string;
  data: Employees[];
}

@Injectable({
  providedIn: 'root'
})
export class OffrollLopManagementService {
     
  private baseUrl = environment.url;
  EmployeeDetailsURL:String='offroll_attendance/employee_details/';
  payAdjustmentURL:String='offroll_attendance/pay_adjustment/'
  ProjectCodeURL:String='offroll_attendance/offroll_projects/'
  companyURL:String='poas/getcompany/'
  designationURL:String='travelex_app/api/v2/designation/'
  fixedReimbursementURL:String='offroll_attendance/fixed_reimbursement/'
  constructor(private http: HttpClient) { }

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken') || '';
    return new HttpHeaders().set('Authorization', token);
  }

  // Methods 
  getEmployees(params: any) {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params[key]) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    const headers = this.getAuthHeaders();
    return this.http.get<Employees[]>(this.baseUrl + this.EmployeeDetailsURL, { params: httpParams , headers: headers });
  }

   //  Bulk SUBMIT (POST) 

  SubmitBulkEmployee(payload:any){
   const headers = this.getAuthHeaders();
   return this.http.post(this.baseUrl + this.payAdjustmentURL , payload, { headers });
  }

   // SINGLE SUBMIT (POST) 
  createPayAdjustment(payload: any) {
    const headers = this.getAuthHeaders();
    return this.http.post(this.baseUrl + this.payAdjustmentURL, payload, { headers });
  }

  // SINGLE UPDATE (PUT) 
  updatePayAdjustment(payload: any) {
    const headers = this.getAuthHeaders();
    return this.http.put(this.baseUrl + this.payAdjustmentURL , payload, { headers });
  }

 // Export Employee details 

exportAllEmployees(params: any): Observable<EmployeeResponse> {
  const headers = this.getAuthHeaders();
  // Build query string from params object
  const queryString = new URLSearchParams(params).toString();
  const url = `${this.baseUrl}${this.EmployeeDetailsURL}?${queryString}`;
  return this.http.post<EmployeeResponse>(url, {}, { headers });
}

  // get project code with params
  getProjectCodeWithParams(params: any): Observable<any> {
    const headers = this.getAuthHeaders();
    let httpParams = new HttpParams();
    
    // Add query parameters to the request
    for (const key in params) {
      if (params[key] !== null && params[key] !== undefined) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    
    return this.http.get(
      this.baseUrl + this.ProjectCodeURL,
      { params: httpParams, headers }
    );
  }

  // get company  in filter
  getCompany(){
  const headers = this.getAuthHeaders();
  return this.http.get(
  this.baseUrl + this.companyURL,{ headers }
  );
  }

  // get designation in filter
  getDesignation(){
  const headers = this.getAuthHeaders();
  return this.http.get(
  this.baseUrl + this.designationURL,{ headers }
  );
  }

  getFixedReimbursement(){
  const headers = this.getAuthHeaders();
  return this.http.get(
  this.baseUrl + this.fixedReimbursementURL,{ headers }
  );
  }

}







